<template>
<div>
    <base-header v-once pageName="메모하기" :popup="true"></base-header>
    
    <section id="wrap" class="h100">
        <div class="sms-input memo">
            <textarea ref="memo" id="memo" :value="memo" v-on:input="checkText($event)" placeholder="메모 내용을 입력해주세요."></textarea>
            <span><em>{{memoLength}}</em>/500</span>
        </div>
    </section>  
    <div class="btnWrap">
        <button type="button" class="red" @click="updateCustMemo()">수정</button>
    </div>  
</div>
</template>

<script>
export default {
    data() {
        return {
            sqno: 0,
            kwkkey: "",
            custDiv: "",
            memoDiv: "",
            memo: "",
            memoLength: 0
        };
    },
    methods: {
        checkText: function (e) {
            if (e.target.id == 'memo') {
                if (e.target.value.length > 500) {
                    e.target.value = e.target.value.substr(0, 500);
                } else {
                    this.memo = e.target.value;
                }
                this.memoLength = e.target.value.length;
            }
        },
        validate() { // 유효성 체크
            if (this.$utils.stringUtil.isNull(this.memo)) {
                alert("메모를 입력해주세요.");
                return false;
            }
            return true;
        },
        updateCustMemo: function () {
            var that = this;
            var validate = this.validate();
            if (!validate) {
                return;
            }
            if (!confirm("저장하시겠습니까?")) {
                return;
            }

            var params = {
                sqno: this.sqno,
                memo: this.memo
            };
            console.log("Memo.vue api.myCstmr.updateCustMemo params:", params);

            this.$api.myCstmr.updateCustMemo(params)
                .then(function () {
                    var child = {
                        name: 'memo-save-complete',
                        data: {res: 'ok'}
                    };
                    that.$utils.nativeIf.outbound.sendChildData(child);
                })
                .catch(function (error) {
                    alert(error.rtMsg);
                });
        }
    },
    mounted: function () { //  인스턴스가 마운트 된 직후
        var parent = this.$store.getters.parent;
        if (parent.name == 'memo-pop-param') {  // 부모창에서 받은 정보.
            console.log("Memo.vue mounted this.$store.getters.parent.data", parent.data);
            this.sqno = parent.data.sqno;
            this.kwkkey = parent.data.kwkkey;
            this.custDiv = parent.data.custDiv;
            this.memoDiv = parent.data.memoDiv;

            this.$api.myCstmr.getCustMemo({sqno: this.sqno})
                .then(res => {
                    this.memo = res.memo.memo;
                    this.memoLength = this.memo.length;
                })
                .catch(err => {
                    alert(err.rtMsg);
                });
        }
    }
};
</script>
